import React from 'react'

import ApplicationProcedureYEE from "./ApplicationProcedureYEE";
import CareerOptionsYEE from "./CareerOptionsYEE";
import EligibilityYEE from "./EligibilityYEE";
import ObjectivesYEE from "./ObjectivesYEE";
import OutcomesYEE from "./OutcomesYEE";
import OverviewYEE from "./OverviewYEE";

const YEE = () => {
  return (
    <div>
    <section id="overview" className="scroll-mt-40">
      <OverviewYEE />
    </section>
    <section id="objectives" className="scroll-mt-40">
      <ObjectivesYEE />
    </section>
    <section id="eligibility" className="scroll-mt-40">
      <EligibilityYEE />
    </section>
    <section id="application-procedure" className="scroll-mt-40">
      <ApplicationProcedureYEE />
    </section>
    <section id="career-options" className="scroll-mt-40">
      <CareerOptionsYEE />
    </section>
    <section id="outcomes" className="scroll-mt-40">
      <OutcomesYEE />
    </section>
  </div>
  )
}

export default YEE;